export default __webpack_public_path__ + "static/media/login-image1.090667d6.png";